import { render, staticRenderFns } from "./FloatingActionButton.vue?vue&type=template&id=4721a0b8"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingActionButton.vue?vue&type=style&index=0&id=4721a0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports